import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import Error from '../../pages/Error';
import appStore from '../../store/App';

type Props = {
  children: ReactNode;
};

class ErrorBoundary extends React.Component<
  Props,
  { hasError: boolean; errorInfo: any }
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  // Убираем componentDidUpdate чтобы избежать бесконечного цикла
  // Сброс ошибки должен происходить через пользовательские действия в Error компоненте

  // Метод для сброса состояния ошибки
  resetErrorBoundary = () => {
    this.setState({ hasError: false, errorInfo: null });
  };

  render() {
    if (this.state.hasError || appStore.isError) {
      return <Error onReset={this.resetErrorBoundary} />;
    }
    return this.props.children;
  }
}

export default observer(ErrorBoundary);
